import React from 'react';
import { Label } from 'reactstrap';
import SpeakerCard from '../../SpeakerCard';

const SelectedSpeakers = ({
  speakers,
  onDelete,
  onActionSpeaker,
  listSpeakers,
}) => {
  const arrJSX = speakers.map((item, index) => {
    const selectedItem = listSpeakers.find(
      (selectedSpeaker) => selectedSpeaker.id === item.id,
    );

    return (
      <SpeakerCard
        key={selectedItem?.id ?? index}
        index={index}
        onDelete={onDelete}
        selectedData={selectedItem}
        onActionSpeaker={onActionSpeaker}
      />
    );
  });

  if (speakers.length > 0) {
    return (
      <div>
        <Label for="formselected" className="text-gray font-weight-bold">
          Selected Speakers
        </Label>
        {arrJSX}
      </div>
    );
  }
  return null;
};

export default SelectedSpeakers;
